import { DayOfWeek, LocalDate, TemporalAdjusters } from "@js-joda/core";

type LockscreenTheme = {
  name: string;
  foreground: string;
  wallpaper: string;
  hideLogo?: boolean;
  position?: string;
  size?: string;
};

export function getLockscreenTheme(): LockscreenTheme {
  const now = LocalDate.now();

  if (isInThanksGiving(now)) {
    return {
      name: "thanks-giving",
      foreground: "#bc520f",
      wallpaper: "assets/happy-thanksgiving-wallpaper.jpg",
    };
  }

  if (isInHolidays(now)) {
    return {
      name: "holidays",
      foreground: "#4f5859",
      wallpaper: "assets/happy-holidays-wallpaper.jpg",
    };
  }

  if (isInMemorialDay(now)) {
    return {
      name: "memorial-day",
      foreground: "#f0f0f0",
      wallpaper: "assets/memorial-day-wallpaper.jpg",
      hideLogo: true,
      position: "top right",
      size: "contain",
    };
  }

  return {
    name: "default",
    foreground: "white",
    wallpaper: "assets/nurse.jpg",
  };
}

export function isInThanksGiving(date: LocalDate) {
  const lastThursdayOfNovember = date
    .withDayOfMonth(1)
    .withMonth(11)
    .with(TemporalAdjusters.dayOfWeekInMonth(4, DayOfWeek.THURSDAY));

  const from = lastThursdayOfNovember.minusDays(4);
  const to = lastThursdayOfNovember.plusDays(1);

  return date.isAfter(from) && date.isBefore(to);
}

export function isInHolidays(date: LocalDate) {
  return date.monthValue() === 12;
}

export function isInMemorialDay(date: LocalDate) {
  const lastMondayOfMay = date
    .withDayOfMonth(1)
    .withMonth(5)
    .with(TemporalAdjusters.lastInMonth(DayOfWeek.MONDAY));

  const startOfCelebration = lastMondayOfMay.minusDays(4);

  return isLocalDateInRange(date, startOfCelebration, lastMondayOfMay);
}

function isLocalDateInRange(date: LocalDate, from: LocalDate, to: LocalDate) {
  return (date.isAfter(from) || date.isEqual(from)) && (date.isBefore(to) || date.isEqual(to));
}
